import React from 'react';
import styles from './Loader.module.css';

const Loader = ({ size = 'medium', text = 'Loading...' }) => {
  const sizeClass = {
    small: styles.small,
    medium: styles.medium,
    large: styles.large
  }[size] || styles.medium;

  return (
    <div className={styles.loaderContainer}>
      <div className={`${styles.spinner} ${sizeClass}`}></div>
      {text && <p className={styles.loaderText}>{text}</p>}
    </div>
  );
};

export default Loader; 